import { useI18n } from "@/i18n/LanguageContext";

const styles = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  pending_confirmation: "bg-amber-50 text-amber-700 border-amber-200",
  pending_payment: "bg-orange-50 text-orange-700 border-orange-200",
  confirmed: "bg-sky-50 text-sea border-sky-200",
  assigned: "bg-indigo-50 text-indigo-700 border-indigo-200",
  en_route: "bg-blue-50 text-blue-700 border-blue-200",
  arrived: "bg-violet-50 text-violet-700 border-violet-200",
  on_board: "bg-teal-50 text-teal-700 border-teal-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};

export const StatusBadge = ({ status, testId }) => {
  const { t } = useI18n();
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
        styles[status] || "bg-slate-100 text-slate-600 border-slate-200"
      }`}
    >
      {t(`status.${status}`) === `status.${status}` ? status : t(`status.${status}`)}
    </span>
  );
};
